import {
  BRANCH_MEDIA_ACCEPTED_TYPES,
  BranchMediaValidation,
} from "@/api/admin/branches";
import type { ValidationConfig } from "@/components/units/MediaUploader/mediaStore";

export const DISH_MEDIA_ACCEPTED_TYPES = BRANCH_MEDIA_ACCEPTED_TYPES;

export const DishMediaValidation: ValidationConfig = {
  image: BranchMediaValidation.image,
  video: BranchMediaValidation.video,
  limits: {
    maxTotal: 5,
  },
};
